import React from "react";
import { Flex, TextField, Select } from "../../../resourses/digitallabs/one-x-ui";
import "../../../styles/DynamicFormRenderer_Helix.css";
import { showCatchError } from "../../../utils/toastMessageUtil";
import { validateSecureInput } from "../../../utils/inputCheckUtility";

const DynamicInputStateCity = ({
  field,
  fieldName,
  value,
  isMain,
  step,
  fieldRefs,
  pincodeLocks,
  multiPincodeOptions,
  safeState,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  normalizeSelectValue,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
  maxLength,
}) => {
  let disabled = !!field.default_answer;

  // 🔒 LOCK LOGIC
  if (field.name === "stateResidence" && pincodeLocks.residence.state) {
    disabled = true;
  }
  if (field.name === "cityResidence" && pincodeLocks.residence.city) {
    disabled = true;
  }
  if (field.name === "stateWork" && pincodeLocks.work.state) {
    disabled = true;
  }
  if (field.name === "cityWork" && pincodeLocks.work.city) {
    disabled = true;
  }

  const safeValue = typeof value === "string" || typeof value === "number" ? value : "";

  const inputValue = field.default_answer ?? String(safeValue);

  /*
  =========================
  RESIDENCE MULTI PINCODE
  =========================
  */
  if (Array.isArray(multiPincodeOptions.residence) && multiPincodeOptions.residence.length > 0) {
    const cities = multiPincodeOptions.residence;

    if (field.name === "stateResidence") {
      return (
        <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper">
          <TextField
            value={safeState["stateResidence"] || ""}
            placeholder="Enter"
            variant="outline"
            size="md"
            disabled
            label={{
              label: renderLabelWithPrefix(isMain, field.question, step),
              optional: !fieldIsRequired(field),
            }}
          />
        </Flex>
      );
    }

    if (field.name === "cityResidence") {
      const options = cities.map((city) => ({
        label: city,
        value: city,
      }));

      return (
        <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper">
          <Select
            items={options}
            value={normalizeSelectValue(value)}
            closeOnSelect
            label={{
              label: renderLabelWithPrefix(isMain, field.question, step),
              optional: !fieldIsRequired(field),
            }}
            valuePlaceholder={`Select ${field.question}`}
            onValueChange={(details) => {
              const selectedValue = details.value?.[0] ?? "";
              updateValue(fieldName, selectedValue);
            }}
            size="md"
          />
        </Flex>
      );
    }
  }

  /*
  =========================
  WORK MULTI PINCODE
  =========================
  */
  if (Array.isArray(multiPincodeOptions.work)) {
    const cities = multiPincodeOptions.work;

    if (field.name === "stateWork") {
      return (
        <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper">
          <TextField
            value={safeState["stateWork"] || ""}
            placeholder="Enter"
            variant="outline"
            size="md"
            disabled
            label={{
              label: renderLabelWithPrefix(isMain, field.question, step),
              optional: !fieldIsRequired(field),
            }}
          />
        </Flex>
      );
    }

    if (field.name === "cityWork" && cities?.length) {
      const options = cities.map((city) => ({
        label: city,
        value: city,
      }));

      return (
        <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper">
          <Select
            items={options}
            value={normalizeSelectValue(value)}
            closeOnSelect
            label={{
              label: renderLabelWithPrefix(isMain, field.question, step),
              optional: !fieldIsRequired(field),
            }}
            valuePlaceholder={`Select ${field.question}`}
            onValueChange={(details) => {
              const selectedValue = details.value?.[0] ?? "";
              updateValue(fieldName, selectedValue);
            }}
            size="md"
          />
        </Flex>
      );
    }
  }

  /*
  =========================
  DEFAULT INPUT
  =========================
  */
  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <TextField
        value={inputValue}
        placeholder="Enter"
        variant="outline"
        size="md"
        label={{
          label: renderLabelWithPrefix(isMain, field.question, step),
          optional: !fieldIsRequired(field),
        }}
        maxLength={maxLength ?? undefined}
        disabled={disabled}
        onBlur={() => {
          if (!validateSecureInput(inputValue)) {
            showCatchError(field.question ? `Invalid input characters in ${field.question}` : "Invalid input characters");
            return;
          }

          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        onChange={(e) => {
          if (!disabled) {
            let val = e.target.value ?? "";

            if (field.rules?.includes("numeric")) {
              val = val.replace(/[^0-9]/g, "");
            }

            if (field.rules?.includes("numeric-float")) {
              val = val.replace(/[^0-9.]/g, "");
            }

            const formatted = field.rules?.includes("emailRule") ? val : val.length > 0 ? val.charAt(0).toUpperCase() + val.slice(1) : "";

            updateValue(fieldName, formatted);
          }
        }}
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />

      {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
    </Flex>
  );
};

export default DynamicInputStateCity;
